import { BlockText, GridContainer, selectThunkRecordById, ViewSection } from "@duosoftbg/nacid-components";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import useUserBirthPlace from "../../../../../../hooks/portal/view/user/useUserBirthPlace";

const PersonViewSection = ({ record }) => {
  const { t } = useTranslation();

  const { birthPlace } = useUserBirthPlace({
    country: record.birthCountry,
    settlement: record.birthSettlement,
    city: record.birthPlace,
  });

  const countriesData = useAppSelector((state) => {
    return state.AppData.countriesData.data;
  });

  const foreignIdData = useAppSelector((state) => {
    return state.AppData.foreignId.data;
  });

  return (
    <ViewSection label={"t.personal.details"}>
      <GridContainer spacing={3} mt={0}>
        <BlockText
          withGrid
          label={"l.person.personalIdType"}
          text={t(`l.person.personalIdType.${record.personalIdType}`)}
        />
        <BlockText
          withGrid
          label={"l.person.foreignerIdentifierKind"}
          text={selectThunkRecordById(record.foreignerIdentifierKind?.id, foreignIdData)?.name}
        />
        <BlockText
          withGrid
          label={"l.person.foreignerIdentifierCountry"}
          text={selectThunkRecordById(record.foreignerIdentifierCountry?.id, countriesData)?.name}
        />
        <BlockText withGrid label={"l.person.personalId"} text={record.personalId} />
        <BlockText withGrid label={"l.person.personalNacidId"} text={record.personalNacidId} />
        <BlockText withGrid label={"l.person.name"} text={record.fullName} />
        <BlockText withGrid label={"l.person.dateOfBirth"} text={record.dateOfBirth} />
        <BlockText
          withGrid
          label={"l.person.birthCountry"}
          text={selectThunkRecordById(record.birthCountry?.id, countriesData)?.name}
        />
        <BlockText withGrid label={"l.person.birthPlace"} text={birthPlace} />
        <BlockText
          withGrid
          label={"l.person.citizenship"}
          text={selectThunkRecordById(record.citizenship?.id, countriesData)?.name}
        />
      </GridContainer>
    </ViewSection>
  );
};
export default PersonViewSection;
